import { createFileRoute } from '@tanstack/react-router';
import { AccountNamePage } from '../components/pages/AccountPage/AccountNamePage';

export const Route = createFileRoute('/account/$accountId_/name')({
  component: AccountNamePage,
});
